var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileExportSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3674_30308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.41333C0 1.4481 0.797222 0.66333 1.77778 0.66333H6.22222V4.16333C6.22222 4.64731 6.61944 5.03833 7.11111 5.03833H10.6667V8.53833H6C5.63056 8.53833 5.33333 8.83091 5.33333 9.19458C5.33333 9.55825 5.63056 9.85083 6 9.85083H10.6667V12.9133C10.6667 13.8786 9.86944 14.6633 8.88889 14.6633H1.77778C0.797222 14.6633 0 13.8786 0 12.9133V2.41333ZM10.6667 9.85083V8.53833H13.725L12.6417 7.47192C12.3806 7.21489 12.3806 6.79927 12.6417 6.54497C12.9028 6.29067 13.325 6.28794 13.5833 6.54497L15.8056 8.73247C16.0667 8.9895 16.0667 9.40513 15.8056 9.65942L13.5833 11.8469C13.3222 12.104 12.9 12.104 12.6417 11.8469C12.3833 11.5899 12.3806 11.1743 12.6417 10.92L13.725 9.85356L10.6667 9.85083ZM10.6667 4.16333H7.11111V0.66333L10.6667 4.16333Z",
    fill: "#B2B2B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3674_30308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white",
    transform: "translate(0 0.66333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExportSolid);
export default __webpack_public_path__ + "static/media/file-export-solid.4500c2badd55d2b2fb9e59a5f6dfc0f9.svg";
export { ForwardRef as ReactComponent };